<template>
  <div class="card">
    <h4 class="margin-t-z margin-b-s">{{ $t('rsvpTrack.yourDriver') }}</h4>
    <div class="no-driver" v-if="provider.ID === null">
      <img src="https://s3-us-west-2.amazonaws.com/mobile-consumer-app/driver.png" />
      <div class="head-message margin-t-m">{{ $t('rsvpTrack.noDriverYet') }}</div>
      <div class="sub-message margin-t-xs">{{ $t('rsvpTrack.driverCheckAgain') }}</div>
    </div>
    <div v-else>
      <div class="row">
        <div class="small-6 column padding-r-s medium-padding-h-s">
          <div class="tracking-profile">
            <img :src="provider.avatarUrl" />
            <div class="head-message margin-t-s">{{ provider.firstName }} {{ provider.lastName }}</div>
            <div class="sub-message rating"><i class="fa fa-star"></i><span>{{ provider.rating }}</span></div>
          </div>
        </div>
        <div class="small-6 column padding-l-s medium-padding-h-s">
          <div class="tracking-profile">
            <img :src="vehicle.photo" />
            <div class="head-message margin-t-s">{{ vehicle.manufacturer }} {{ vehicle.model }}</div>
            <div class="sub-message">{{ vehicle.plate }}</div>
          </div>
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="small-6 end column padding-r-s small-padding-h-s">
          <div class="contact-information">
            <div>{{ $t('rsvpTrack.phone') }}</div>
            <a :href="'tel:' + phone">{{ phone }}</a>
          </div>
        </div>
        <div class="small-6 end column padding-l-s small-padding-h-s" v-if="provider.email">
          <div class="contact-information">
            <div>{{ $t('rsvpTrack.email') }}</div>
            <a :href="'mailto:' + provider.email">{{ provider.email }}</a>
          </div>
        </div>
        <div class="small-12 medium-4 column padding-l-s small-padding-h-s" v-if="false">
          <div class="contact-information">
            <div>{{ $t('rsvpTrack.driverLicense') }}</div>
            <span>{{ provider.driverLicenseNumber }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'driver-information',
  computed: {
    provider () { return this.$store.state.rsvpTrack.rsvp.provider },
    vehicle () { return this.$store.state.rsvpTrack.rsvp.vehicle },
    phone () {
      let x = `${this.provider.phones[0].countryCode}${this.provider.phones[0].phoneNumber}`
      return x.includes('+') ? x : `+${x}`
    }
  }
}
</script>

<style lang="scss" scoped>
.no-driver {
  text-align: center;
  & img {
    display: block;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    border-radius: 100%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    border: 1px solid rgba(0,0,0,0.2);
  }

  & .head-message{
    font-size: 18px;
    font-weight: 700;
  }

  & .sub-message{
    color: #777;
  }
}

.tracking-profile {
  text-align: center;

  & img {
    display: block;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    border-radius: 100%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    border: 1px solid rgba(0,0,0,0.2);
  }

  & .head-message{
    font-size: 18px;
    font-weight: 700;
  }

  & .sub-message{
    color: #777;
    font-size: 16px;
    line-height: 16px;
  }

  & .rating {
    & > * {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }

    & i { color: #FFCC33; }
  }
}

.contact-information {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// DriverInformation.vue?49034256